import Rollbar from 'rollbar';
import { getRollbar } from '../rollbar';

function sendError(...args: Rollbar.LogArgument[]): Rollbar.LogResult {
  return getRollbar().error(...args);
}
export { sendError };
